module.exports = __webpack_public_path__ + "static/media/contele_system.13959886.png";